import React, { useEffect, useState } from 'react';
import { Application } from '../../../entities/Application';
import { Col, Row } from 'reactstrap';
import { CandidateProcessActivityPanel } from './CandidateProcessActivityPanel';
import {
  ApplicationFeedList,
  ApplicationFeedService,
} from '../../../services/applicant_tracking/ApplicationFeedService';
import { User } from '../../../entities/User';
import { PendingActionsPanel } from '../ProfileTab/PendingActionsPanel';
import { JobHiringMemberRole } from '../../../entities/JobHiringMemberRole';
import { HiringTeam } from '../../JobPage/OverviewTab/HiringTeam';
import {
  ActivityTabFilter,
  defaultFilters,
} from './CandidateProcessActivityPanel/ActivityTabFilters';
import _ from 'lodash';
import { AccountIntegration } from '../../../entities/AccountIntegration';
import { AlertObject } from '../../../components/Alert';

interface PropTypes {
  application: Application;
  currentUser: User;
  jobHiringMemberRole?: JobHiringMemberRole;
  emailAccountIntegration: AccountIntegration;
  setAlert: (data: AlertObject) => void;
  reloadApplication?: () => void;
  applicationStylesPath: string;
}

export function ActivityTab(props: PropTypes) {
  const [page, setPage] = useState<number>(1);
  const [filters, setFilters] = useState<ActivityTabFilter>(defaultFilters);

  const [applicationFeedList, setApplicationFeedList] =
    useState<ApplicationFeedList>(null);
  const briefJobDetails = props.application.candidate.applications.find(
    (application) => application.id === props.application.id,
  )?.job;

  const fetchApplicationFeedList = () => {
    setApplicationFeedList(null);

    ApplicationFeedService.list(
      props.application.id.toString(),
      page,
      filters,
    ).then((list) => {
      setApplicationFeedList(list);
    });
  };

  useEffect(fetchApplicationFeedList, [props.application, page]);

  useEffect(() => {
    page === 1 ? fetchApplicationFeedList() : setPage(1);
  }, [filters]);

  const handleFilterUpdate = (newFilters) => {
    const filtersChanged = !_.isEqual(filters, newFilters);

    if (filtersChanged) {
      setFilters(newFilters);
    }
  };

  return (
    <div className='d-flex'>
      <div className='d-flex flex-column gap-3 w-100'>
        <div className='fs-2 fw-bold'>Activity</div>
        <Row className='flex-nowrap'>
          <Col xs='9'>
            <CandidateProcessActivityPanel
              application={props.application}
              applicationFeedList={applicationFeedList}
              currentUser={props.currentUser}
              emailAccountIntegration={props.emailAccountIntegration}
              setAlert={props.setAlert}
              reloadApplication={props.reloadApplication}
              onPageClick={(page) => setPage(page)}
              onFilter={handleFilterUpdate}
              applicationStylesPath={props.applicationStylesPath}
            />
          </Col>
          <Col>
            <HiringTeam
              hiringMembers={briefJobDetails?.hiringMembers ?? []}
              className='p-3 mb-3'
            />
            <PendingActionsPanel {...props} />
          </Col>
        </Row>
      </div>
    </div>
  );
}
